import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaHistory } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

type Props = {
  data: { id?: number };
  auditTable: string;
};

/**
 * Εικονίδιο παραπομπής στο Audit Trail για τη συγκεκριμένη εγγραφή.
 * Ανοίγει το grid με φίλτρα πίνακα/id, χωρίς ημερομηνία ώστε να φαίνεται όλο το ιστορικό.
 */
export const AuditTrailTooltip = ({ data, auditTable }: Props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const auditId = data?.id;

  const onClick = () => {
    if (!auditTable || !auditId) return;
    history.push({
      pathname: '/audit-trails',
      state: { filterValues: { tableRowId: auditId, tableName: auditTable } },
    });
  };

  if (!auditTable || !auditId) return null;

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      delay={{ show: 300, hide: 300 }}
      overlay={<Tooltip id={`audit-trail-${auditId}`}>{t('Audit Trail')}</Tooltip>}
      placement="left"
    >
      <span
        onClick={onClick}
        style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
      >
        <FaHistory size="1.5rem" className="pe-1" />
      </span>
    </OverlayTrigger>
  );
};
